export default "__VITE_ASSET__BMiMvhY5__"